import { createFileRoute } from '@tanstack/react-router'

import { PlatformScriptsPage } from '../../../components/pages/backoffice/platform/platform-scripts-page/platform-scripts-page.tsx'
import { PermissionChecker } from '../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/scripts')({
  component: () => (
    <PermissionChecker requiredPermissions={['job.runEphemeral']}>
      <PlatformScriptsPage />
    </PermissionChecker>
  ),
})
